import React, { useState } from 'react';
import PropTypes from 'prop-types';

import copyToClipboard from 'utils/clipboard';

import {
  Wrapper,
  PromptText,
  LeftContent,
  CopyButton,
  CopyButtonText
} from './styled';

const PromptCard = ({
  text,
  copyValue,
  copyLabel = 'Copy',
  className
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const clipboardValue = copyValue || (typeof text === 'string' ? text : '');

    copyToClipboard(clipboardValue);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Wrapper className={ className }>
      <LeftContent>
        <PromptText>{text}</PromptText>
      </LeftContent>
      <CopyButton onClick={ handleCopy } type="button">
        <CopyButtonText>{copied ? 'Copied!' : copyLabel}</CopyButtonText>
      </CopyButton>
    </Wrapper>
  );
};

PromptCard.propTypes = {
  text: PropTypes.node.isRequired,
  copyValue: PropTypes.string,
  copyLabel: PropTypes.string,
  leadingIcon: PropTypes.node,
  className: PropTypes.string
};

PromptCard.defaultProps = {
  copyValue: '',
  copyLabel: 'Copy',
  leadingIcon: null,
  className: ''
};

export default PromptCard;
